// extracted by mini-css-extract-plugin
module.exports = {"block":"empty-block_block__07gQn","heading":"empty-block_heading__B06I8","text":"empty-block_text__i7sMg"};